var _radialGradient, _linearGradient, _linearGradient2, _radialGradient2, _linearGradient3, _linearGradient4, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _radialGradient7, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _radialGradient8, _radialGradient9, _linearGradient16, _radialGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWindmill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 189.5532234094,
    cy: 123.2072309798,
    gradientUnits: "userSpaceOnUse",
    r: 355.6919740128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2752,
    stopColor: "#88e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4407,
    stopColor: "#80e1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772,
    stopColor: "#72e2d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#5ee3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8083,
    stopColor: "#43e4c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9096,
    stopColor: "#23e5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 483.3491896498,
    x2: 143.6026091552,
    y1: 437.3418538026,
    y2: 97.5951729158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#00e7b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4308,
    stopColor: "#1bc4b7",
    stopOpacity: 0.427451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b9abe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3952,
    stopColor: "#39375d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    stopColor: "#323154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8179,
    stopColor: "#262846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9849,
    stopColor: "#151a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 212.9778358276,
    cy: 360.9823417762,
    gradientUnits: "userSpaceOnUse",
    r: 204.4463058872,
    xlinkHref: "#c"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 190.035407146,
    x2: 321.964812854,
    y1: 303.8673117444,
    y2: 303.8673117444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2336,
    stopColor: "#ff6b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#ff6143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#ff504e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7434,
    stopColor: "#ff395e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    stopColor: "#ff1b72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 329.7029432378,
    x2: 191.881619704,
    y1: 325.8584239388,
    y2: 188.037100405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0084",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#f4087e",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#d2216b",
    stopOpacity: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#ba335e",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#ab3d56",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 296.9967,
    cy: -11.5018,
    gradientTransform: "matrix(.709873 -.709873 -.929531 -.929531 119.199925 480.229998)",
    gradientUnits: "userSpaceOnUse",
    r: 89.7151,
    xlinkHref: "#c"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 296.9961,
    cy: 28.1039,
    gradientTransform: "matrix(.709873 -.709873 .929531 .929531 -77.167736 283.861333)",
    gradientUnits: "userSpaceOnUse",
    r: 89.7152,
    xlinkHref: "#c"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 196.9695,
    cy: 28.1042,
    gradientTransform: "matrix(.709873 .709873 -.929531 .929531 227.021503 -78.285402)",
    gradientUnits: "userSpaceOnUse",
    r: 89.7151,
    xlinkHref: "#c"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 196.97,
    cy: -11.5023,
    gradientTransform: "matrix(.709873 .709873 .929531 -.929531 30.65334 118.082259)",
    gradientUnits: "userSpaceOnUse",
    r: 89.7152,
    xlinkHref: "#c"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8421,
    stopColor: "#131830"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7908732258,
    x2: 265.2484402484,
    xlinkHref: "#k",
    y1: 211.5523669798,
    y2: 164.0099340024
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 318.177517109,
    x2: 250.726507734,
    xlinkHref: "#k",
    y1: 237.1932376052,
    y2: 169.742127838
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 298.9105,
    cy: 184.9862,
    gradientTransform: "matrix(.709873 -.709873 .709873 .709873 -105.365685 255.663385)",
    gradientUnits: "userSpaceOnUse",
    r: 60.1692,
    xlinkHref: "#n"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(.709873 -.709873 .709873 .709873 -105.365685 255.663385)",
    gradientUnits: "userSpaceOnUse",
    x1: 305.0916,
    x2: 305.0916,
    xlinkHref: "#k",
    y1: 354.693,
    y2: 389.9398
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(-.709873 .709873 -.709873 -.709873 803.826447 440.56315)",
    gradientUnits: "userSpaceOnUse",
    x1: 205.0645,
    x2: 205.0645,
    xlinkHref: "#k",
    y1: 717.3878,
    y2: 752.6346
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 255.218949 -106.483049)",
    gradientUnits: "userSpaceOnUse",
    x1: 205.0654,
    x2: 205.0654,
    xlinkHref: "#k",
    y1: 354.6928,
    y2: 389.9396
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientTransform: "matrix(-.709873 -.709873 .709873 -.709873 70.319285 802.708781)",
    gradientUnits: "userSpaceOnUse",
    x1: 305.0909,
    x2: 305.0909,
    xlinkHref: "#k",
    y1: 717.3876,
    y2: 752.6345
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6688497734,
    x2: 253.9665655968,
    xlinkHref: "#k",
    y1: 498.6946393808,
    y2: 376.215251851
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 255.9998088234,
    x2: 255.9998088234,
    xlinkHref: "#n",
    y1: 410.7879161182,
    y2: 455.9476406208
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7282,
    stopColor: "#e3f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#d8ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9756,
    stopColor: "#c7e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 338.6161643226,
    cy: 266.7493036384,
    gradientUnits: "userSpaceOnUse",
    r: 166.6709296556,
    xlinkHref: "#v"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 214.3372466078,
    cy: 283.1064055688,
    gradientUnits: "userSpaceOnUse",
    r: 43.1012828338,
    xlinkHref: "#v"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 196.1088340694,
    x2: 106.9716036114,
    xlinkHref: "#k",
    y1: 328.2730571332,
    y2: 239.1358266752
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 101.5407,
    cy: -48.0065,
    gradientTransform: "matrix(.475156 .884355 .884355 -.475156 40.408445 240.56571)",
    gradientUnits: "userSpaceOnUse",
    r: 162.3992,
    xlinkHref: "#v"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m287.59375 510.058594c126.476562-15.566406 224.40625-123.371094 224.40625-254.058594 0-23.359375-3.148438-45.984375-9.007812-67.488281l-143.269532-143.269531c-5.839844-5.839844-13.398437-8.625-20.878906-8.5625-2.671875.019531-5.332031.40625-7.90625 1.144531-1.027344.292969-2.042969.644531-3.035156 1.054687-1.988282.816406-3.898438 1.851563-5.6875 3.113282-1.339844.941406-2.613282 2.007812-3.804688 3.195312-1.582031 1.585938-3.015625 3.382812-4.25 5.390625l-5.605468 9.09375-38.355469 62.238281-76.609375-76.722656c-1.191406-1.1875-2.464844-2.253906-3.804688-3.195312-1.789062-1.261719-3.699218-2.296876-5.6875-3.113282-.996094-.410156-2.007812-.761718-3.035156-1.054687-1.027344-.296875-2.074219-.535157-3.125-.714844-.527344-.089844-1.054688-.167969-1.585938-.230469-1.058593-.125-2.128906-.191406-3.195312-.199218-7.480469-.058594-15.035156 2.726562-20.878906 8.5625l-17.453125 17.457031-17.457031 17.457031c-2.921876 2.917969-5.078126 6.269531-6.496094 9.820312-.203125.511719-.390625 1.023438-.5625 1.535157-.34375 1.03125-.628906 2.078125-.855469 3.132812-.113281.523438-.210937 1.054688-.296875 1.585938-.488281 3.117187-.464844 6.289062.046875 9.382812.023437.15625.050781.308594.078125.464844 1.128906 6.1875 4.226562 12.035156 9.1875 16.480469l75.234375 75.234375c.109375.097656.226563.183593.335937.277343l-62.25 38.363282-9.089843 5.601562c-1.535157.945313-2.945313 2.007813-4.230469 3.160156-7.558594 6.773438-10.808594 16.804688-9.3125 26.328126.085938.53125.183594 1.0625.296875 1.585937.226563 1.054687.511719 2.101563.855469 3.132813.175781.515624.363281 1.027343.566406 1.535156 1.417969 3.550781 3.574219 6.902344 6.492188 9.820312l81.507812 81.507813-8.839844 43.394531zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m93.550781 453.855469c44.195313 36.328125 100.773438 58.144531 162.449219 58.144531s118.253906-21.816406 162.449219-58.144531c-42.359375-12.765625-99.53125-20.59375-162.449219-20.59375s-120.09375 7.828125-162.449219 20.59375zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m321.964844 412.5c-21.511719-1.144531-43.550782-1.722656-65.964844-1.722656-22.417969 0-44.453125.578125-65.964844 1.722656l44.246094-217.265625h43.4375zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m317.9375 392.730469-40.21875-197.496094h-43.4375l-19.261719 94.578125zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m270.84375 169.035156-29.6875 29.683594 73 118.457031c9.90625 16.070313 32.214844 18.679688 45.566406 5.335938l34.910156-34.914063c13.347657-13.347656 10.734376-35.660156-5.335937-45.5625zm0 0",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m270.84375 169.035156-29.6875 29.683594-118.453125-73c-16.074219-9.90625-18.683594-32.214844-5.335937-45.566406l34.910156-34.910156c13.351562-13.347657 35.660156-10.734376 45.566406 5.335937zm0 0",
    fill: "url(#h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m270.84375 198.71875-29.6875-29.683594 73.003906-118.457031c9.902344-16.070313 32.210938-18.683594 45.5625-5.335937l34.910156 34.910156c13.347657 13.351562 10.734376 35.660156-5.335937 45.566406zm0 0",
    fill: "url(#i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m270.84375 198.71875-29.6875-29.683594-118.453125 73c-16.074219 9.902344-18.683594 32.214844-5.335937 45.5625l34.910156 34.914063c13.351562 13.347656 35.660156 10.734375 45.566406-5.335938zm0 0",
    fill: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m287.09375 156.785156c-.375-.398437-.746094-.792968-1.128906-1.175781-7.445313-7.421875-17.726563-12.027344-29.078125-12.027344-.015625 0-.03125.003907-.046875.003907l-15.683594 25.449218 29.6875 29.683594 36-22.183594zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m311.472656 279.8125 47.59375-51.058594-13.953125-13.949218-74.269531-45.769532-29.6875 29.683594 17.308594 28.085938zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m298.070312 184.765625c0 22.742187-18.4375 41.179687-41.183593 41.179687-22.742188 0-41.179688-18.4375-41.179688-41.179687 0-22.746094 18.4375-41.183594 41.179688-41.183594 22.746093 0 41.183593 18.4375 41.183593 41.183594zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m314.160156 317.175781c9.902344 16.070313 32.210938 18.679688 45.5625 5.335938l34.910156-34.914063c13.347657-13.347656 10.734376-35.660156-5.335937-45.5625l-9.089844-5.601562-71.652343 71.652344zm0 0",
    fill: "url(#p)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m197.84375 50.578125c-9.90625-16.070313-32.214844-18.683594-45.566406-5.335937l-34.910156 34.910156c-13.347657 13.351562-10.734376 35.660156 5.335937 45.566406l9.089844 5.601562 71.652343-71.652343zm0 0",
    fill: "url(#q)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m122.703125 242.035156c-16.074219 9.902344-18.683594 32.214844-5.335937 45.5625l34.910156 34.914063c13.351562 13.347656 35.660156 10.734375 45.566406-5.335938l5.601562-9.09375-71.652343-71.652343zm0 0",
    fill: "url(#r)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m389.296875 125.71875c16.070313-9.90625 18.683594-32.214844 5.335937-45.5625l-34.910156-34.914062c-13.351562-13.347657-35.660156-10.734376-45.5625 5.335937l-5.605468 9.09375 71.652343 71.648437zm0 0",
    fill: "url(#s)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m396.949219 469.730469c-.515625-.648438-1.121094-1.21875-1.808594-1.6875-.578125-.851563-1.3125-1.585938-2.164063-2.164063-.578124-.851562-1.316406-1.585937-2.164062-2.164062-.582031-.851563-1.316406-1.585938-2.167969-2.167969-.578125-.847656-1.3125-1.585937-2.164062-2.164063-.578125-.851562-1.316407-1.585937-2.164063-2.164062-.578125-.851562-1.316406-1.585938-2.164062-2.164062-.582032-.851563-1.316406-1.585938-2.167969-2.167969-.578125-.851563-1.3125-1.585938-2.164063-2.164063-.578124-.851562-1.316406-1.585937-2.164062-2.164062-.582031-.851563-1.316406-1.585938-2.167969-2.164063-.578125-.851562-1.3125-1.589843-2.164062-2.167969-.425781-.628906-.941407-1.191406-1.527344-1.679687-33.757813-5.917969-72.539063-9.285156-113.792969-9.285156-26.441406 0-51.859375 1.390625-75.597656 3.9375v8.296875c0 2.808594 1.421875 5.285156 3.582031 6.753906l59.4375 59.4375c4.164063.199219 8.355469.3125 12.574219.3125 52.078125 0 100.523438-15.554688 140.949219-42.269531zm0 0",
    fill: "url(#t)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m323.421875 453.664062h-134.84375c-4.515625 0-8.171875-3.660156-8.171875-8.171874v-37.816407c0-4.511719 3.65625-8.171875 8.171875-8.171875h134.84375c4.515625 0 8.171875 3.660156 8.171875 8.171875v37.816407c0 4.511718-3.65625 8.171874-8.171875 8.171874zm0 0",
    fill: "url(#u)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m204.847656 318.039062c12.03125 16.964844 26.773438 31.007813 42.808594 43.046876 2.003906 1.507812 4.039062 2.964843 6.089844 4.402343 2.042968 1.445313 4.097656 2.863281 6.179687 4.242188 4.164063 2.757812 8.429688 5.347656 12.699219 7.878906 4.285156 2.515625 8.65625 4.871094 13.066406 7.085937 1.058594.546876 2.289063 1.171876 3.367188 1.6875 1.082031.507813 2.144531 1.050782 3.238281 1.523438 1.089844.488281 2.171875.980469 3.273437 1.425781 1.09375.46875 2.195313.910157 3.304688 1.328125 17.660156 6.929688 36.527344 9.785156 55.007812 8.574219 18.480469-1.164063 36.585938-6.367187 52.714844-15.15625 16.136719-8.773437 30.289063-21.078125 41.207032-35.984375 1.382812-1.851562 2.691406-3.757812 3.976562-5.6875l1.839844-2.902344c.480468-.835937 1.007812-1.648437 1.433594-2.507812.480468-.839844.855468-1.722656 1.277343-2.589844.355469-.890625.765625-1.769531 1.058594-2.6875.65625-1.8125 1.199219-3.671875 1.585937-5.578125.414063-1.898437.65625-3.839844.765626-5.796875.128906-1.960938.09375-3.9375-.09375-5.90625-.066407-.988281-.234376-1.96875-.34375-2.960938-.175782-.976562-.320313-1.964843-.5625-2.9375-.4375-1.949218-1.007813-3.886718-1.75-5.761718-.734376-1.875-1.574219-3.730469-2.597657-5.484375-.996093-1.773438-2.078125-3.519531-3.34375-5.140625-2.480469-3.28125-5.507812-6.1875-8.914062-8.699219-1.695313-1.277344-3.503907-2.414063-5.390625-3.417969-1.875-1.035156-3.859375-1.871094-5.890625-2.617187-4.054688-1.511719-8.402344-2.433594-12.859375-2.683594-2.226563-.171875-4.484375-.140625-6.75.035156-2.269532.15625-4.53125.527344-6.78125 1.027344-2.261719.480469-4.503906 1.140625-6.691406 1.984375-2.191407.835938-4.359376 1.816406-6.449219 2.96875-2.105469 1.140625-4.132813 2.457031-6.074219 3.925781-1.960938 1.449219-3.832031 3.0625-5.570312 4.835938-.910157.859375-1.726563 1.800781-2.582032 2.730469-.804687.96875-1.609375 1.917968-2.417968 2.957031-1.605469 2.042969-3.238282 4.074219-4.886719 6.09375.929687-2.4375 1.878906-4.863281 2.855469-7.273438.457031-1.203125 1.039062-2.425781 1.582031-3.648437.613281-1.1875 1.195312-2.410156 1.894531-3.566406 2.710938-4.675782 6.21875-9.011719 10.394531-12.71875 1.027344-.949219 2.125-1.816407 3.226563-2.699219 1.136718-.820313 2.269531-1.667969 3.472656-2.410157 2.371094-1.546874 4.878906-2.914062 7.496094-4.085937 2.613281-1.183594 5.339844-2.148437 8.136718-2.90625 2.796876-.769531 5.667969-1.363281 8.585938-1.695313 5.832031-.664062 11.839844-.457031 17.738281.648438 2.945313.578125 5.867188 1.355469 8.710938 2.390625 2.851562 1.007813 5.636719 2.226563 8.316406 3.667969 10.734375 5.726562 19.980469 14.921875 25.65625 26.128906 1.453125 2.78125 2.667969 5.695312 3.6875 8.679688 1.023437 2.984374 1.847656 6.054687 2.371094 9.183593.558593 3.125.882812 6.300781.953125 9.492188.085937 3.1875-.050782 6.398437-.457032 9.582031-.390624 3.183594-.980468 6.363281-1.886718 9.457031-.410156 1.5625-.960938 3.078125-1.476563 4.605469-.585937 1.5-1.148437 3.019531-1.835937 4.476562-.640625 1.484376-1.390625 2.910157-2.140625 4.339844-.71875 1.304688-1.394531 2.488282-2.105469 3.734375-1.445312 2.441407-2.929688 4.859375-4.507812 7.222657-12.585938 18.941406-30.050782 34.761718-50.171876 45.539062-20.105468 10.832031-42.847656 16.605469-65.539062 16.746094-11.351562.097656-22.667969-1.308594-33.621094-3.949219-5.484375-1.304687-10.851562-3.042969-16.09375-5.027344-5.238281-2-10.359375-4.273437-15.265625-6.925781-1.234375-.652344-2.453125-1.324219-3.65625-2.027344-1.214843-.675781-2.398437-1.402344-3.585937-2.121094-1.195313-.703124-2.347656-1.480468-3.519532-2.21875l-3.316406-2.1875c-4.464844-3.003906-8.8125-6.140624-13.042968-9.417968-4.242188-3.257813-8.316407-6.726563-12.285157-10.285156-1.984375-1.78125-3.933593-3.601563-5.855469-5.445313-1.898437-1.871094-3.773437-3.757813-5.605468-5.6875-3.675782-3.847656-7.199219-7.832031-10.515625-11.980469-3.335938-4.125-6.476563-8.398437-9.382813-12.820312-5.800781-8.832032-10.742187-18.21875-14.15625-28.050782zm0 0",
    fill: "url(#w)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m202.1875 281.707031c3.621094 3.332031 6.46875 6.683594 9.21875 10.09375 2.730469 3.398438 5.167969 6.886719 7.550781 10.414063 2.367188 3.535156 4.578125 7.175781 6.6875 10.980468 1.015625 1.941407 2.074219 3.859376 3.019531 5.929688.921876 2.085938 1.921876 4.140625 2.621094 6.566406-4.65625-1.605468-8.613281-4.203125-12.09375-7.242187-3.527344-3.015625-6.496094-6.566407-9.050781-10.382813-2.546875-3.820312-4.605469-7.96875-6.054687-12.367187-1.402344-4.402344-2.394532-9.042969-1.898438-13.992188zm0 0",
    fill: "url(#x)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m156.597656 250.703125c-1.222656-1.273437-2.570312-2.394531-3.886718-3.570313-2.589844-2.402343-5.40625-4.523437-8.230469-6.648437-3.03125-2.167969-6.167969-4.199219-9.382813-6.085937l-12.394531 7.636718c-16.074219 9.902344-18.683594 32.214844-5.335937 45.5625l34.910156 34.914063c13.351562 13.347656 35.660156 10.734375 45.566406-5.335938l9.605469-15.589843zm0 0",
    fill: "url(#y)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m44.84375 222.957031c6.761719 1.445313 13.226562 2.894531 19.601562 4.515625 6.367188 1.601563 12.609376 3.277344 18.722657 5.175782 12.246093 3.722656 23.964843 8.242187 35.25 13.542968 5.625 2.699219 11.101562 5.652344 16.511719 8.78125 5.386718 3.171875 10.613281 6.628906 15.828124 10.25l3.847657 2.824219c1.296875.933594 2.582031 1.886719 3.835937 2.890625 1.269532.984375 2.523438 1.996094 3.824219 2.972656 1.289063.992188 2.488281 2.074219 3.765625 3.101563 2.605469 2.011719 5 4.25 7.597656 6.390625 1.3125 1.058594 2.519532 2.210937 3.800782 3.328125 1.285156 1.109375 2.574218 2.234375 3.957031 3.320312-2.042969-6.597656-4.910157-12.945312-8.523438-18.871093-.910156-1.472657-1.808593-2.972657-2.777343-4.417969-.996094-1.425781-2.039063-2.816407-3.066407-4.234375-.527343-.695313-1.011719-1.4375-1.582031-2.09375l-1.695312-2c-1.140626-1.324219-2.242188-2.703125-3.453126-3.96875l-3.691406-3.761719c-1.222656-1.273437-2.574218-2.394531-3.886718-3.570313-2.589844-2.402343-5.40625-4.523437-8.230469-6.648437-5.746094-4.105469-11.832031-7.753906-18.207031-10.792969-12.769532-6.023437-26.519532-9.8125-40.390626-11.105468-6.9375-.636719-13.90625-.671876-20.800781-.027344-3.445312.324218-6.875.816406-10.261719 1.523437-3.382812.707031-6.746093 1.570313-9.976562 2.875zm0 0",
    fill: "url(#z)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindmill);
export default __webpack_public_path__ + "static/media/icon-windmill.3ec43bca4304a07575fc8e8607e59cfd.svg";
export { ForwardRef as ReactComponent };